export const closedMessageDefault = {
  TITLE: 'The waitlist is currently closed.',
  SUBTITLE: 'We reopen {{nextOpen}}',
}